import { createContext, useContext } from 'react';
import type { AuthUser } from '@/utils/auth';

export interface AuthContextValue {
  user: AuthUser | undefined;
  setUser?: (user: AuthUser | undefined) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextValue | undefined>(undefined);

/* eslint-disable react-refresh/only-export-components -- hook and context are co-located by design */
export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext);
  if (value === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return value;
}

export { AuthContext };
